var React = require('react');

function FacebookCircleInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"21.5","cy":"21.5","r":"21.5","fill":"#333333","key":0}),React.createElement("path",{"d":"M12.0909 10C10.9474 10 10 10.9474 10 12.0909V30.9091C10 32.0526 10.9474 33 12.0909 33H30.9091C32.0526 33 33 32.0526 33 30.9091V12.0909C33 10.9474 32.0526 10 30.9091 10H12.0909ZM12.0909 12.0909H30.9091V30.9091H25.4858V23.8523H28.1974L28.5895 20.7159H25.4858V18.6903C25.4858 17.7756 25.7104 17.1548 27.0213 17.1548H28.7202V14.3125C28.4302 14.2757 27.4256 14.2145 26.2699 14.2145C23.8604 14.2145 22.2187 15.6642 22.2187 18.3636V20.7159H19.4744V23.8523H22.2187V30.9091H12.0909V12.0909Z","fill":"white","key":1})]);
}

FacebookCircleInline.defaultProps = {"width":"43","height":"43","viewBox":"0 0 43 43","fill":"none"};

module.exports = FacebookCircleInline;

FacebookCircleInline.default = FacebookCircleInline;
